'use strict';

var _classCallCheck = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/inherits");

var EventEmitter = require('events').EventEmitter;

var Connection = require('interface-connection').Connection;

var toPull = require('stream-to-pull-stream');

var pull = require('pull-stream');

var pullCatch = require('pull-catch');

var setImmediate = require('async/setImmediate');

var debug = require('debug');

var log = debug('mplex');
log.error = debug('mplex:error');

var MULTIPLEX_CODEC = require('./codec');

function noop() {} // Catch error makes sure that even though we get the "Channel destroyed" error
// from when closing streams, that it's not leaking through since it's not
// really an error for us, channels shoul close cleanly.


function catchError(stream) {
  return {
    source: pull(stream.source, pullCatch(function (err) {
      if (err.message === 'Channel destroyed') {
        return;
      }

      return false;
    })),
    sink: stream.sink
  };
}

var MultiplexMuxer =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(MultiplexMuxer, _EventEmitter);

  function MultiplexMuxer(conn, multiplex) {
    var _this;

    _classCallCheck(this, MultiplexMuxer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MultiplexMuxer).call(this));
    _this.multiplex = multiplex;
    _this.conn = conn;
    _this.multicodec = MULTIPLEX_CODEC;
    multiplex.on('close', function () {
      return _this.emit('close');
    });
    multiplex.on('error', function (err) {
      return _this.emit('error', err);
    });
    multiplex.on('stream', function (stream, id) {
      var muxedConn = new Connection(catchError(toPull.duplex(stream)), _this.conn);

      _this.emit('stream', muxedConn);
    });
    return _this;
  }
  /**
   * Conditionally emit errors if we have listeners. All other
   * events are sent to EventEmitter.emit
   *
   * @param {string} eventName
   * @param  {...any} args
   * @returns {void}
   */


  _createClass(MultiplexMuxer, [{
    key: "emit",
    value: function emit(eventName) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (eventName === 'error' && !this._events.error) {
        log.error.apply(log, ['error'].concat(args));
      } else {
        var _get2;

        (_get2 = _get(_getPrototypeOf(MultiplexMuxer.prototype), "emit", this)).call.apply(_get2, [this, eventName].concat(args));
      }
    } // method added to enable pure stream muxer feeling

  }, {
    key: "newStream",
    value: function newStream(callback) {
      callback = callback || noop;
      var stream;

      try {
        stream = this.multiplex.createStream();
      } catch (err) {
        return setImmediate(function () {
          return callback(err);
        });
      }

      var conn = new Connection(catchError(toPull.duplex(stream)), this.conn);
      setImmediate(function () {
        return callback(null, conn);
      });
      return conn;
    }
    /**
     * Destroys multiplex and ends all internal streams
     *
     * @param {Error} err Optional error to pass to end the muxer with
     * @param {function()} callback Optional
     * @returns {void}
     */

  }, {
    key: "end",
    value: function end(err, callback) {
      if (typeof err === 'function') {
        callback = err;
        err = null;
      }

      callback = callback || noop;
      this.multiplex.destroy(err);
      callback();
    }
  }]);

  return MultiplexMuxer;
}(EventEmitter);

module.exports = MultiplexMuxer;